// extracted by mini-css-extract-plugin
module.exports = {"iconStyles-style-fontSize":"36px","welcome":"_7GmQ6huwljHE8TQcUt2S1"};